import InvoicesTable from 'pages/invoices/InvoicesTable';
import { useDefaultInvoiceTabKey } from 'pages/invoices/util/useDefaultInvoiceTabKey';
import { useValidInvoiceTab } from 'pages/invoices/util/useValidInvoiceTab';
import { Navigate, useParams } from 'react-router-dom';

interface Props {
    contactId?: string;
}

const InvoiceView: React.FC<Props> = ({ contactId }) => {
    const { invoiceTab } = useParams<{ invoiceTab?: string }>();
    const isValidTab = useValidInvoiceTab(invoiceTab);
    const defaultTabKey = useDefaultInvoiceTabKey();

    if (!contactId || !isValidTab) {
        return null;
    }

    // No `:invoiceTab` segment yet → redirect to the last-selected (or default) sub-tab so the
    // active tab is always reflected in the URL and restored across visits, mirroring the global
    // invoices list.
    if (invoiceTab === undefined) {
        return <Navigate to={`/contact/${contactId}/invoices/${defaultTabKey}`} replace />;
    }

    return (
        <div className="flex h-full flex-col gap-4">
            <InvoicesTable
                key={invoiceTab}
                passiveFilter={`(clientParty.id=in=(${contactId}),invoiceMatters.matter.clientParty.id=in=(${contactId}))`}
                contactId={contactId}
                defaultShowTotals
                disabledGroups={['invoices.filter.client-group']}
                pathBasedTabId={invoiceTab}
            />
        </div>
    );
};

export default InvoiceView;
